import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { useAuth } from "./AuthContext";
import { fetchMissions, claimMission as apiClaim } from "../utils/missionsApi";

const MissionsContext = createContext(null);

export const MissionsProvider = ({ children }) => {
  const { user } = useAuth();
  const [missions, setMissions] = useState(null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) {
      setMissions(null);
      return;
    }
    setLoading(true);
    try {
      const data = await fetchMissions();
      setMissions(data);
    } catch {
      /* invité ou erreur réseau : ignoré */
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const claim = useCallback(
    async (category, missionId) => {
      const res = await apiClaim(category, missionId);
      await refresh();
      return res;
    },
    [refresh]
  );

  const claimableCount = missions
    ? ["daily", "weekly", "monthly"].reduce(
        (acc, cat) => acc + (missions[cat]?.missions || []).filter((m) => m.completed && !m.claimed).length,
        0
      )
    : 0;

  return (
    <MissionsContext.Provider value={{ missions, loading, refresh, claim, claimableCount }}>
      {children}
    </MissionsContext.Provider>
  );
};

export const useMissions = () => {
  const ctx = useContext(MissionsContext);
  if (!ctx) throw new Error("useMissions must be used within MissionsProvider");
  return ctx;
};
